class BISForm extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.addEventListener('submit', this.handleBISSubmit.bind(this))
  }

  handleBISSubmit (event) {
    event.preventDefault()
    const selectedVariant = this.getAttribute('variant-id')

    this.backInStockSubscribe(selectedVariant, this.els.email.element.value)
  }

  async backInStockSubscribe (variantId, emailAddress) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: `${emailAddress}`,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.status === 202) {
        this.handleBISSuccessView()
        this.trackSubscriptionEvent(variantId)
      } else {
        console.error(response)
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }

  handleBISSuccessView () {
    const event = new CustomEvent('backInStockSubscribed', {
      bubbles: true,
    })
    this.dispatchEvent(event)
  }

  trackSubscriptionEvent (variantId) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'back_in_stock_subscription',
      variantId,
    })
  }
}

if (!customElements.get('bis-form')) {
  customElements.define('bis-form', BISForm, {
    extends: 'form',
  })
}
